import { useEffect, useState } from 'react';
import s from './index.module.css';
import Search from "@UI/Search/new";
import CheckboxViolet from '../../../../../UI/New/ChecboxViolet/CheckboxViolet';
import { usersAPI } from '../../../../../../api';
import classNames from 'classnames';
import Preloader from '../../../../../UI/Preloader';
import Button from '@UI/Button';
//import { Checkbox } from 'antd';

const UserSearch = ({
    selectUsers,
    setSelectUser,
    closeModal = () => {},
    roleSeach = ''
}) => {
    const [newUsers, setNewUsers] = useState([]);

    const [search, setSearch] = useState('');
    const [users, setUsers] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    useEffect(() => {
        if(search?.trim()?.length < 3) return;

        setSearchLoading(true);
        usersAPI.getUsersCancel({
                filter: [`[search]=${search}`],
                ...(!!roleSeach && {'filter[role][eq]': roleSeach}),
                'filter[status]': 10,
                pageSize: 50
        }).then(res => {
            if (res.status === 200) {
                setUsers(res.data.data);
            }
            setSearchLoading(false);
        })
    }, [search]);

    return (<>
        <div className={s.info}>
            Введите <span style={{fontWeight: '600'}}>минимум 3 буквы</span> для поиска учащихся и нажмите enter
        </div>
        <Search
            className={classNames(s.search, 'searchNewDesign', 'backgroundNone')}
            {...{search, setSearch}} />
            { search && <div className={s.users}>
                {!searchLoading && users.map(user =>
                    <UserCheckbox
                        user={user}
                        selectUsers={selectUsers}
                        setSelectUser={setSelectUser}
                        setNewUsers={setNewUsers}
                    />
                )}
                { searchLoading && <Preloader />}
            </div>
            }
            <Button 
                newDesign
                action={closeModal}
                disable={!newUsers?.length}
                className={s.buttonPrimary}>Сохранить</Button>
    </>)
}

export default UserSearch;

const UserCheckbox = ({
    user,
    selectUsers,
    setSelectUser,
    setNewUsers
}) => {
    const value = selectUsers.some(el => el.id === user.id);
    const setValue = () => {
        if (value) {
            setNewUsers((prev) => prev.filter(userId => userId != user.id));
            setSelectUser(selectUsers.filter(el => el.id != user.id));
        } else {
            setNewUsers(prev => ([...prev, user.id]));
            setSelectUser([...selectUsers, user]);
        }
    }

    return (<div className={s.searchItem} key={user.id}>
        <CheckboxViolet
            text={<>
                {user.name}
                <span style={{ color: '#555', marginLeft:'15px'}}>({!!user.email && user.email} {!!user.phone && !!user.email && `, `} {!!user.phone && user.phone})</span>
            </>}
            value={value}
            setValue={setValue}
            blockClassName={s.checkboxBlock}
            textClassName={s.checkboxText1}
        />
    </div>);
}